import { attentionItemSchema, type AttentionItem } from '@growup/streaming-shared';
import { Card, Notice, StatusBadge } from '@growup/ui';
import { useEffect, useState } from 'react';
import { z } from 'zod';

import { getJson, messageOf } from '../api';
import { formatDate } from '../format';
import { CHECKUP_LOOK, formatMinutes, TOPIC_LABEL } from './labels';

export const loadAttention = () =>
  getJson('/api/streaming/checkups/attention', z.array(attentionItemSchema));

/**
 * "Precisa de atenção" (GS2, Stream Staff): the streamers whose latest padrinho
 * report says "Precisa de atenção" or "Não consegui falar". A newer "Tudo bem"
 * takes them off the list.
 */
export function AttentionView() {
  const [items, setItems] = useState<AttentionItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    loadAttention()
      .then(setItems)
      .catch((e: unknown) => setError(messageOf(e)));
  }, []);

  return (
    <div className="flex flex-col gap-4">
      {error ? <Notice tone="danger">{error}</Notice> : null}
      {items && items.length === 0 ? (
        <p className="text-gu-ink-muted">
          Ninguém precisa de atenção. Aparece aqui quem o padrinho marcar no relatório como “Precisa
          de atenção” ou “Não consegui falar”.
        </p>
      ) : null}
      {items?.map(({ streamer, checkup: c }) => (
        <Card
          key={streamer.id}
          headingLevel={2}
          title={streamer.displayName}
          eyebrow={`Relatório de ${c.padrinho} a ${formatDate(c.createdAt)} · twitch.tv/${streamer.channel}`}
          actions={
            <StatusBadge tone={CHECKUP_LOOK[c.status].tone}>
              {CHECKUP_LOOK[c.status].label}
            </StatusBadge>
          }
        >
          {c.topics.length > 0 ? <p>Em: {c.topics.map((t) => TOPIC_LABEL[t]).join(', ')}</p> : null}
          {c.note ? <p className="whitespace-pre-line">{c.note}</p> : null}
          <p className="text-caption text-gu-ink-muted">
            Desde {formatDate(c.period.from)}: {c.period.sessions} transmissões,{' '}
            {formatMinutes(c.period.minutesLive)}
          </p>
        </Card>
      ))}
    </div>
  );
}
